import type { FunctionComponent } from "react";

import classNames from "classnames";

import RegionCellContent from "app/components/React/Table/cells/RegionCellContent";
import RegionService from "app/services/RegionService";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

export const RegionCell: FunctionComponent<ITableCellProps> = ({ className, value }) => {
    const region = RegionService.getRegionById(value.toString());

    return (
        <div className={classNames("swTable-countryCell", className)}>
            <RegionCellContent
                regionCode={value}
                text={region.name}
            />
        </div>
    );
};
RegionCell.displayName = "RegionCell";
